export const environment = {
    production: true,
    apiHost: "https://api.mediamonorail-staging.com",
    signInUrl: "https://api.mediamonorail-staging.com/authorize",
    connectUrl: "https://mediamonorail-staging.com/assets/connect/v4",
    version: require('../../package.json').version,
    monorailV4URL: "https://v4.mediamonorail-staging.com"
  };
  


// WEBPACK FOOTER //
// ./src/environments/environment.ts